/**
 * BFF endpoint root response
 */
export interface BFFRoot<C> {
  content: C
  traceKey: string
  isValid: boolean
  [x: string]: any
  retry?: {
    intervalInSeconds: number
    attempts: number
  }
}

/**
 * BFF paging structure
 */
export interface BFFPaging {
  totalItems: number
  currentPage: number
  pageSize: number
  pageCount: number
  [x: string]: any
}

/**
 * Credit paginated response interface
 */
export interface CreditPaging<T> {
  items: T
  paging: BFFPaging
}

/**
 * BFF paging interface for list responses type
 */
export type BFFRootList<I> = BFFRoot<CreditPaging<I>>

/**
 * BFF V2 contract type structure
 */
export interface BFFDictionary<
  V,
  T = string | 'enum' | 'date' | 'money' | 'integer' | 'percentage' | 'boolean',
  D = string
> {
  value: V
  type: T
  description: D
}

export interface MicroJonStructure {
  definitions?: any
  navigation?: any
  drawers?: any
  screen: any
  [x: string]: unknown
}

export interface CustomResponseScreensJsonStructure {
  content?: MicroJonStructure
  trace_key?: string | null
  is_valid?: boolean
}

export type V1ScreensCreateResponse = CustomResponseScreensJsonStructure

export interface V1ScreensCreateParams {
  /** Filter only resources belonging to this document */
  Document?: string
  /** @maxLength 255 */
  id: string
}

export interface AllServicesQueryParams {
  Document: string
}

export enum SurveysCheckDisplayComponentType {
  Score = 'Score',
  YesNo = 'YesNo',
  MultipleChoice = 'MultipleChoice',
  MultipleChoiceSingle = 'MultipleChoiceSingle'
}
